import { useUser } from '~/@biz_account/useUser/useUser'
import { getActiveStepIndex, getSteps } from './steps'

export type OnboardingStepsColorScheme = 'dark' | 'light'

function useOnboardingSteps() {
  const { user } = useUser()
  const steps = getSteps(user ?? null)
  const activeStep = getActiveStepIndex(user ?? null)
  const colorScheme: OnboardingStepsColorScheme = 'dark'
  return { steps, activeStep, colorScheme }
}

export { useOnboardingSteps }
